const initialFilters = {
    searchFilters: {},
    pagination: {
        currentPage: 1,
        pageSize: 10,
    },
    refreshIndex: 0
};


export const initialState = {
    items: [],
    politicalPreferences: [],
    countries: [],
    totalCount: 0,
    filters: initialFilters,
    requestData: {},
    isLoading: false,
    indexVisibility: 0,
    refreshIndex: 0,
    elm: '',
    itemSelected: null,
};


export const reducer = (state, action) => {
    switch (action.type) {
        case "set_loading":
            return { ...state, isLoading: action.payload };
        case "set_request_data":
            return { ...state, requestData: action.payload };
        case "set_index_visibility":
            return { ...state, indexVisibility: action.payload };
        case "set_items":
            return { ...state, items: action.payload.items, totalCount: action.payload.total };
        case "set_political_preferences":
            return { ...state, politicalPreferences: action.payload };
        case "set_countries":
            return { ...state, countries: action.payload };
        case "set_search_filters":
            return { ...state, filters: { ...state.filters, searchFilters: action.payload } };
        case "refresh_list":
            return { ...state, filters: { ...state.filters, refreshIndex: state.filters.refreshIndex + 1 } };
        case "set_table_pagination":
            return { ...state, filters: { ...state.filters, pagination: action.payload } }
        case "open_edit_view":
            return { ...state, itemSelected: action.payload.item, indexVisibility: action.payload.indexVisibility };
        default:
            return state;
    }
};